export default `<h1 style="text-align:center">
<strong><span style=";font-family:微软雅黑;font-size:29px">&nbsp;<span style="font-family:微软雅黑">Ai优米数字化平台用户协议</span></span></strong>
</h1>
<h2>
<strong><span style=";font-family:微软雅黑;font-size:19px">导言</span></strong>
</h2>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">本协议是</span> Ai优米用户与 Ai优米数字化平台之间关于您成为 Ai优米用户所订立的有效契约，具有法律效力。“ Ai优米用户”完成了成为 Ai优米用户的程序且在服务期限内遵守相关使用规则下的享有 Ai优米软件使用权的自然人。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">&nbsp;</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">本协议构成您获取和使用</span> Ai优米服务之必要前提条件，您应当在仔细阅读并同意本协议的全部内容后获取和使用 Ai优米。如您不同意本协议的任一内容，无法进行下一步操作。您的使用行为（包括但不限于支付行为/接受赠与、或完成了成为用户的全部程序而在此过程中未向 Ai优米数字化平台提出关于本协议的任何异议、或使用 Ai优米等）将视为同意本协议的全部内容。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">如您在阅读本协议或获取</span>/使用 Ai优米的过程中有任何疑惑或其他相关事宜的，请联系相关负责人， Ai优米工作人员会尽快为您作出解答。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">本协议将帮助您了解以下内容：</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">1. 服务说明</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">2. 成为 Ai优米用户的程序</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">3. Ai优米流量费用相关（含自动续费）</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">4. Ai优米用户权利及限制</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">5. 服务的中断和终止</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">6. 广告及通知</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">7. 联系方式</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">8. 法律的适用和管辖</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">9. 其他</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">&nbsp;</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">1. 服务说明</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">1.1 Ai优米用户服务涉及的 Ai优米产品/服务的所有权及相关知识产权均归 Ai优米数字化平台所有或拥有合法授权（经合法渠道取得的实体产品所有权、账号下归属于用户的个人财产、 Ai优米数字化平台另有说明的其他权益除外）。 Ai优米数字化平台提供的服务将按照其服务条款和操作规则严格执行。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">1.2 本协议为《 Ai优米服务协议》、《 Ai优米隐私政策》的补充协议，是其不可分割的一部分；本协议如与前述协议发生冲突的，以本协议为准。 Ai优米已有和未来不时发布的与 Ai优米用户服务相关的协议、各类公告、页面说明和规范流程、问题解答等内容均构成本协议的一部分，与本协议具有同等法律效力。 Ai优米数字化平台与 Ai优米用户都应当受本协议以及《 Ai优米服务协议》、《 Ai优米隐私政策》的约束。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">1.3 如在 Ai优米软件展示了其他付费内容的，当您需要时，由对应的其他收费体系与您签署相应的服务协议、向您提供相应的服务并收取费用。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">2. 成为 Ai优米用户的程序</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">2.1 Ai优米会在相关页面上为您做出每一步的明确操作指引。您应保证提交所含信息的稳定性、真实性、准确性、合法性和有效性，否则当您使用 Ai优米出现问题导致无法使用或操作出现问题的，与 Ai优米无关， Ai优米不因此向您退还您已充值或缴纳的流量费用，损失和责任均由您自行承担。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">2.2 在您阅读和同意本协议全部内容、充值了流量费用（如收费）并完成了成为 Ai优米用户的其他所有程序后，您即取得“ Ai优米企业版”的免费使用资格，在您持续遵守 Ai优米相关服务使用规则下，即能够享受 Ai优米用户服务。如您不同意前述任一流程或内容的，您应立即停止下一步操作。一旦您完成了成为 Ai优米用户的所有程序，即视为您对所有流程及其内容无异议。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">2.3 您知悉并同意， Ai优米用户服务系统管理软件“企业版 Ai优米”，采用先储值流量费后服务的方式，一经开通后不可转让或退款。您可以通过登录 Ai优米用户中心免费查询您的账号信息详情，包括储值余额、服务内容、服务期限、消费记录等。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">2.4 Ai优米用户账号的所有权归 Ai优米所有， Ai优米用户仅在 Ai优米授权范围内拥有 Ai优米账号的有限使用权。您应自行负责妥善且正确地保管、使用、维护您的账户（包括账户信息及密码、系统内客户资料等），您应对您的账户信息和密码采取必要和有效的保密措施。非 Ai优米原因致使您账户信息被篡改、密码泄露以及其他因保管、使用、维护不当而造成的损失，您应自行承担责任， Ai优米在法律允许的最大范围内无须承担与此有关的任何责任。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">3. Ai优米用户流量费用相关（含自动续费）</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">3.1 Ai优米为用户服务为免费服务，使用该服务前需以储值自动扣减余额的方式支付相应的流量费用。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">3.2 关于自动续费服务：</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>1）自动续费服务是指在用户已开通 Ai优米的前提下，出于用户对于自动续费的需求，避免用户因疏忽或其他原因导致未能及时续费而推出的服务。如用户选择开通自动续费服务的，即用户授权 Ai优米可在余额不足或服务期限即将过期导致软件无法使用时，委托支付渠道从与 Ai优米用户账号绑定的自有充值账户、与用户账号绑定的第三方支付账户、银行卡、与苹果商店账户绑定的支付账户等账户（以下统称“账户”）余额中代扣下一个计费周期的费用。该服务实现的前提是您已将您的 Ai优米账号、苹果商店账户与上述账户中的一种进行绑定，且可成功从其上述账户中足额扣款。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>2）计费周期：如余额不足一百元、月度、季度、年度等（具体以 Ai优米提供的为准）。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>3）自动扣款规则：</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">a. Ai优米用户选择开通自动续费的，则视为同意授权 Ai优米可在用户服务计费周期即将过期时，依据支付渠道的扣款规则向账户发出扣款指令，并同意账户可以根据 Ai优米发出的扣款指令，在不验证用户账户密码、支付密码、短信校验码等信息的情况下从账户中扣划下一个计费周期的费用。一旦扣款成功， Ai优米将为用户开通下一个计费周期的用户服务，且将在扣划成功的当天将扣划款项记入用户支付记录，并同时相应延长用户服务期限；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">b.除非用户主动明确地取消了自动续费，否则， Ai优米用户对 Ai优米的自动扣款委托长期有效、不受次数限制；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">c.您知悉并同意，您使用第三方支付渠道支付费用的，您还将受到该第三方服务条款、使用规则的约束；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">d.如果 Ai优米在用户服务期限即将过期前通过您的账户扣款失败的，无论是因金额不足或其他原因， Ai优米有权在用户服务计费周期到期后暂停或终止您对 Ai优米软件的使用。但由于自动续费服务需要您主动操作取消，如果您未进行此等操作，则将视为您同意 Ai优米可依据支付渠道的扣款规则在用户计费周期到期后的一定期限内进行不时的扣款尝试（即使您账户内金额不足）。一旦在此期限内 Ai优米足额收取了费用， Ai优米将恢复您对自动续费服务和 Ai优米用户服务的使用权限；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>4） 取消方式：您可以随时以任何理由取消自动续费服务。 Ai优米已在产品内为您详细展示了取消方式及取消步骤，您可至相关页面进行查阅，如您在取消过程中遇到问题的，可通过本协议提供的方式与 Ai优米联系。您知悉并同意，虽然您按照前述操作方法取消了自动续费服务，但在取消前已经委托 Ai优米自动续费的扣款指令仍然有效， Ai优米对于基于该指令在取消操作完成前已经扣除的费用不予退还且不予支付任何形式的赔偿/补偿，相关责任与损失由您自行承担。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>5） 责任分担原则：如在扣费过程出现差错， Ai优米和您应密切配合查明原因，各自承担己方过错造成的损失；若因双方各自存在不均等过错造成损失的，由双方按过错的程度承担相应责任；因双方共同过错造成损失但无法区分各自过错的，由双方均摊责任。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">3.3 您在充值或购买 Ai优米内付费服务（包括自动续费服务）之前应仔细核对账号信息、购买的服务内容、价格、服务期限等信息。服务费用在您支付完成后，不可转让，且不予退还（如因用户服务存在重大瑕疵导致您完全无法使用等除外）。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">3.4 Ai优米用户流量（包括自动续费）的收费标准由 Ai优米根据自身运营策略独立决定（包括费用调整），并在费用支付页面向您显示；若在自动续费时/之前，软件流量价格发生调整的，应以 Ai优米软件上公示的现时有效的价格为准。您同意您继续操作的行为（包括但不限于点击同意、或继续购买、或完成支付行为、使用 Ai优米等），即视为您知悉并同意该收费标准。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">4. Ai优米用户权利及限制</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">4.1您知悉并同意，您应遵循 Ai优米官方渠道公布的流程、使用规范等获取/使用 Ai优米资格和 Ai优米用户服务、以及参与面向用户举办的相关活动，不得自行或协助他人通过以下任一方式获取/使用 Ai优米资格和 Ai优米用户服务、或参与相关活动。否则， Ai优米有权不经通知拒绝您的申请或撤销涉及的 Ai优米账户、拒绝或终止为您提供服务，并不退还用户支付的任何费用，且不予支付任何形式的任何赔偿/补偿，同时 Ai优米有权追究您的相关法律责任：</span>
</p>
<p>
<span style="font-family:微软雅黑;font-size:13px">（1）&nbsp;</span><span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">未经</span> Ai优米明确授权，以商业性或其他非个人使用等目的为自己或他人获取、使用 Ai优米软件提供服务；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>2） 未经 Ai优米明确授权，通过智能体软件、蜘蛛软件、爬虫软件等任何自动程序、脚本、软件等方式获取 Ai优米用户服务、内容、数据；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>3） 未经 Ai优米明确授权，通过技术手段对服务内容、服务期限、消费金额、交易状态等信息进行修改；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>4） 将 Ai优米用户资料通过非 Ai优米明确授权的方式在 Ai优米用户账号之间转移，或未经 Ai优米明确授权而赠与、借用、租用、销售、转让 Ai优米用户资格；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>5） 对 Ai优米用于保护 Ai优米用户的任何安全措施技术进行破解、更改、反操作、篡改或其他破坏；未经 Ai优米事先书面同意而删除 Ai优米软件内容上的任何所有权或知识产权声明或标签；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>6） 通过不正当手段或以违反诚实信用原则的方式（如利用规则漏洞、利用系统漏洞、滥用用户身份、黑色产业、投机等违背 Ai优米提供服务/举办活动的初衷的方式）；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>7） 通过侵犯 Ai优米或他人合法权益的方式；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>8） 其他未经 Ai优米明示授权许可或违反本协议、法律法规或监管政策的行为。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">4.2 您知悉并同意，如您存在或 Ai优米经独立判断后认为您存在任何违反国家法律法规或监管政策、违反本协议或有损 Ai优米或/及其关联公司的声誉、利益的行为的， Ai优米有权独立决定采取以下一项或多项处理措施：</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>1） 如本协议对此行为有单独条款约定处理方式的，按照该条款处理；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>2） 无需通知您而采取一种或多种措施制止您的行为及行为产生的后果，如删除/屏蔽相关链接或内容、限制/取消您的账号/账户使用权限等；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>3） 无需通知您而中断或终止部分或全部软件用户服务，且您已储值的软件费用将不予退还且不获得任何形式的补偿/赔偿；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>4） 如您的行为使 Ai优米或/及其关联公司遭受任何损失的，您应当承担全部损失赔偿责任并在 Ai优米要求的时限内完成费用支付。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">5. 服务的中断和终止</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">5.1 在发生如下情况时， Ai优米有权中断或终止向您提供的 Ai优米软件服务：</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>1） 您主动提出要求的；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>2） 您存在或 Ai优米经独立判断后认为您存在任何违反国家法律法规或监管政策、违反本协议或有损 Ai优米或/及其关联公司的声誉、利益的行为的；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>3） Ai优米根据法律法规、监管政策的规定或有权机关的要求；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>4） Ai优米为维护账号与系统安全等紧急情况之需要；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>5） 不可抗力（鉴于互联网之特殊性质，不可抗力亦包括黑客攻击、电信部门技术调整导致之重大影响、因政府管制而造成之暂时关闭、病毒侵袭等影响互联网正常运行之情形）；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>6） 其他 Ai优米无法抗拒的情况。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">5.2 当发生前述终止的情况时，您与 Ai优米均认可如下处理方式：</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>1） 已经产生但未使用的 Ai优米用户权益自动清除且不折现；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>2） 如您在 Ai优米软件内有正在进行中的交易， Ai优米届时将视情况进行合理处理；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>3） 除法律法规另有规定或 Ai优米另有说明外， Ai优米已收取的费用不予退还；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>4） 如因您违反本协议导致终止的， Ai优米有权视情况要求您承担相应的违约责任；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>5） 除法律法规另有规定或 Ai优米另有说明外， Ai优米无需向您和第三人承担任何责任。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">6. 广告及通知</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">6.1关于 Ai优米广告特权的特别说明：您在使用 Ai优米的过程中，仍将（可能）接触到以各种方式投放的商业性广告或其他类型的商业信息。 Ai优米可能以投放广告或商业信息，如开机广告、跑马灯广告、植入广告、弹窗广告等，上述呈现不视为 Ai优米侵权或违约，对此您理解并予以接受，同时 Ai优米承诺会尽量降低对您使用软件的影响。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">6.2为便于您获知与本协议和 Ai优米用户服务相关的信息，您同意 Ai优米有权通过网页公示、页面提示、弹窗、消息通知、公众号通知、您预留的联系方式（如手机短信、电子邮件等）等一种或多种方式进行通知，该通知自 Ai优米发送之时视为已成功送达您。如多种通知方式并存的，则送达时间以上述方式中最早发送之时为准。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">7. 联系方式</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">7.1 如您对本协议或使用 Ai优米软件服务的过程中有任何问题（包括问题咨询、投诉等）， Ai优米专门为您提供了多种反馈通道，希望为您提供满意的解决方案：</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>1） 其他在线意见反馈通道：您可与 Ai优米客服人员联系反馈意见</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>2） 专设的邮件通道： Ai优米专门设立了ls0797@qq.com 邮箱，您可以通过该邮箱与 Ai优米联系；</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px"><span style="font-family:微软雅黑">（</span>4） 其他方式： Ai优米提供的其他反馈通道。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">7.2 我们会在收到您的反馈后尽快向您答复。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">8. 法律的适用和管辖</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">8.1 本协议的生效、履行、解释及争议的解决均适用中华人民共和国法律。如本协议因与中华人民共和国现行法律相抵触而导致部分无效的，不影响协议的其他部分的效力。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">8.2 如就本协议的签订、履行等发生任何争议的，双方应尽量友好协商解决；协商不成时，任何一方均可向深圳市龙华区人民法院提起诉讼。双方同意，解决争议时，应以您同意的最新《 Ai优米用户服务协议》为准。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">9. 其他</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">9.1 本协议的标题仅为方便及阅读而设，并不影响正文中任何条款的含义或解释。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">9.2 Ai优米未行使或延迟行使其在本协议项下的权利并不构成对这些权利的放弃，而单一或部分行使其在本协议项下的任何权利并不排斥其任何其它权利的行使。 Ai优米随时有权要求您继续履行义务并承担相应的违约责任。</span>
</p>
<p>
<span style=";font-family:微软雅黑;font-size:13px">9.3 本协议</span><span style=";font-family:微软雅黑;font-size:13px">自用户注册平台时</span><span style=";font-family:微软雅黑;font-size:13px">即时生效。</span>
</p>
<p>
<br/>
</p>`